module.exports = __webpack_public_path__ + "static/media/bk-offers-active.df5005ff.png";